import {UPDATE_ERROR, errorReducerType} from '../actions/types/error.types';

export interface ErrorReducerState {
    error: {
        status: string;
        message: string;
        raw: object;
    };
}
export const preloadedState: ErrorReducerState = {
    error: {
        status: '',
        message: '',
        raw: {},
    },
};
export const errorReducer = (state: ErrorReducerState = preloadedState, action: errorReducerType): ErrorReducerState => {
    switch (action.type) {
        case UPDATE_ERROR:
            return {
                ...state,
                error: {...action.error},
            };
        default:
            return state;
    }
};
